import { useContext, useEffect, useState } from "react"
import StoreContext, { CartItem } from "../../context/storeContext"
import { Avatar, Badge, Button, Input, InputNumber, List, Radio, Table } from "antd";
import Title from "antd/es/typography/Title";
import Card from "../../components/Card";
import { getCartDiscount, getCartTotal, getTotalStock, getUser } from "../../helpers";
import { AuthService } from "../../services/AuthService";
import { Link } from "react-router-dom";
import { ClearOutlined, DeleteOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import ButtonGroup from "antd/es/button/button-group";
import "./cart.css";
import { UserContext } from "../../context/userContext";

const ViewCart = () => {
    const { user } = useContext(UserContext);
    const [submittingOrder, setSubmittingOrder] = useState(false);
    const { cart, emptyCart, addToCart, decreaseQuantity, setItemQuantity,removeFromCart } = useContext(StoreContext);
    const [applySale, setApplySale] = useState(true);
    // ?applySale=false
    const [cartTotal, setCartTotal] = useState({
        total: null,
        discount: null,
        priceAfterDiscount: null
    })

    const [columns, setColumns] = useState([

        {
            title: 'Shifra e Prodhuesit',
            dataIndex: 'barcode',
            key: 'barcode',
        },
        {
            title: 'Numri i Katalogut',
            dataIndex: 'productNo',
            key: 'productNo',
        },
        {
            title: 'Përshkrimi',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Çmimi',
            dataIndex: 'price',
            key: 'price',
            render: (_, record) => {

                return (
                    <>  
                        {record?.discountedPrice ?record?.discountedPrice.toFixed(2): record?.price.toFixed(2)}€
                    </>
                );
            }
        },
        {
            title: 'Sasia',
            dataIndex: 'qc',
            key: 'qc',
            render: (_, record) => {

                return (
                    <>
                        {/* <Button disabled={getTotalStock(record) < 4} type={"primary"} size="large" /> */}
                        {cartItem(record)}
                    </>
                );
            }
        },
        {
            title: 'Totali',
            dataIndex: 'total',
            key: 'total',
            render: (_, record) => {

                return (
                    <>
                        {/* <Button disabled={getTotalStock(record) < 4} type={"primary"} size="large" /> */}
                        {cartItemTotal(record)}
                    </>
                );
            }
        },
        {
            title: 'Fshij',
            dataIndex: 'delete',
            key: 'delete',
            render: (_, record) => {

                return (
                    <>
                        {/* <Button disabled={getTotalStock(record) < 4} type={"primary"} size="large" /> */}
            <Button type="primary" size="small" danger onClick={()=> {
                removeFromCart(record?.productId)
            }}><DeleteOutlined /></Button>
                        
                    </>
                );
            }
        },
    ]);


    const updateQuantity = (value, item) => {

        if(value <= 0){
            alert("fshije prej cart");
            removeFromCart(item?.productId);
            return;
        }
        if (value < 1 || value > 100) {
            return;
        }
        else if (item?.quantity >= getTotalStock(item)) {
            setItemQuantity(item, value - 1);
            return;
        }
        setItemQuantity(item, value)
    }

    const cartItem = (item) => {
        return (
            <>
                <ButtonGroup>
                    {/* <Button size="small" onClick={() => onDecrement(item)} icon={<MinusOutlined />} /> */}
                    <InputNumber min={0} max={getTotalStock(item)} onChange={(val) => updateQuantity(val, item)} value={item?.quantity} className="quantity-input" />
                    {/* <Button size="small" onClick={() => onIncrement(item)} icon={<PlusOutlined />} /> */}
                </ButtonGroup>
            </>
        )
    }

    const cartItemTotal = (item) => {
        return (
            <p className="mb-2">{`${(item?.quantity * (item?.discountedPrice ? item?.discountedPrice : item?.price)).toFixed(2)}`}€</p>

        )
    }



    const submitOrder = async () => {
        setSubmittingOrder(true);
        let user = await getUser();
        console.log("user", user)

        if (cart && cart.length > 0) {
            let order = {
                userId: user?.user?.id,
                items: []
            }

            order.items = cart.map(el => ({
                barcode: el.barcode,
                quantity: el.quantity
            }));

            console.log("order", order);

            if (!order.userId) {
                alert("dicka shkoi gabim!!");
            }
            else if (order.items.length < 1) {
                alert("nuk keni produkte ne shporte");
            }
            else {
                let res = await AuthService.createOrder(order, applySale);
                console.log("res", res);
                emptyCart();
            }


        }
        setTimeout(() => {
            setSubmittingOrder(false);
        }, 2000);

    }

    // useEffect(()=>{
    //     alert("changed")
    //     setCartTotal({...cartTotal, total:getCartTotal(cart), discount: getCartDiscount(cart), priceAfterDiscount:getCartTotal(cart) - getCartDiscount(cart) })
    // }, [cart])



    useEffect(() => {
        console.log("Cart", cart)
    }, [])


    return (
        <div className="container">
            <div className="d-flex justify-content-between align-items-center mb-2">
                <Title level={4} style={{ fontWeight: '400', fontFamily: 'Source Sans 3' }}>Shporta e blerjeve</Title>
                <div className="d-flex justify-content-start">
                    {cart && cart?.length > 0 && <Button onClick={emptyCart} type="primary" icon={<ClearOutlined />}>Fshij shporten</Button>}

                </div>
            </div>
            <div className="row">
                <div className="col-lg-8">
                    {/* <Card title="Produktet" style={{padding: 0}}>
                        <></>
                        <List

                            dataSource={cart}
                            renderItem={(item: CartItem, index) => (
                                <Badge.Ribbon text="Ska ne stok" color="red" style={item?.quantity <= getTotalStock(item) ? {display: "none"} :{}}>
                                <List.Item>
                                    <List.Item.Meta
                                        // avatar={<Avatar src={`https://api.dicebear.com/7.x/miniavs/svg?seed=${index}`} />}
                                        title={<a href="https://ant.design">{item?.name} / {item?.barcode}</a>}
                                        description={<CartItemRender item={item} onIncrement={addToCart} onDecrement={decreaseQuantity} updateCartQuantity={setItemQuantity} />}
                                    />
                                </List.Item>
                                </Badge.Ribbon>
                            )}
                        />
                    </Card> */}
                    <Table dataSource={cart} pagination={false} size="small" columns={columns} rowKey={"productId"} style={{ width: "100%" }} />

                </div>
                <div className="col-lg-4 mt-lg-0 mt-md-4">
                    <Card title="Totali i shportes">
                        <div className="row">
                            {user?.details?.roleName !== "User" && (
                                <div className="col-12 mb-3">

                                    <Radio.Group onChange={(e) => setApplySale(e.target.value)} value={applySale}>
                                        <Radio value={true}>Apliko zbritjen</Radio>
                                        <Radio value={false}>Pa zbritje</Radio>
                                    </Radio.Group>
                                </div>
                            )}
                            {/* {user?.details?.roleName !== "User" && (
                                <>
                                    <div className="col-lg-6">
                                        <p>Totali:</p>
                                    </div>
                                    <div className="col-lg-6">
                                        <p>{cartTotal?.total} {getCartTotal(cart)}€</p>
                                    </div>
                                </>
                            )} */}
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <p style={{ color: "red" }}>Zbritje:</p>
                            </div>
                            <div className="col-lg-6">
                                <p style={{ color: "red" }}>{applySale ? (getCartTotal(cart) - getCartDiscount(cart)).toFixed(2) : 0}€</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <p>Totali pas zbritjes:</p>
                            </div>
                            <div className="col-lg-6">
                                <p>{applySale ? getCartDiscount(cart).toFixed(2) : getCartTotal(cart)}€</p>
                            </div>
                        </div>
                        <div className="row mt-3">
                            <div className="col-12">
                                <Button disabled={submittingOrder || cart?.length < 1} loading={submittingOrder} type="primary" block onClick={submitOrder}>
                                    Perfundo porosine
                                </Button>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    )
}

const CartItemRender = ({ item, onIncrement, onDecrement, updateCartQuantity }) => {

    const onChange = (value) => {

        if (value < 1 || value > 100) {
            return;
        }
        else if (item?.quantity >= getTotalStock(item)) {
            updateCartQuantity(item, value - 1);
            return;
        }
        updateCartQuantity(item, value)
    }

    return (
        <>
            <p className="mb-2">{`${item?.quantity} x ${item?.discountedPrice} € = ${item?.quantity * item?.discountedPrice}`} {item?.discountedPrice < item?.price ? <span style={{ textDecoration: "line-through" }}>{`(${item?.price}€)`}</span> : <></>}</p>
            <ButtonGroup>
                {/* <Button size="small" onClick={() => onDecrement(item)} icon={<MinusOutlined />} /> */}
                <InputNumber min={1} max={100} onChange={onChange} value={item?.quantity} className="quantity-input" />
                {/* <Button size="small" onClick={() => onIncrement(item)} icon={<PlusOutlined />} /> */}
            </ButtonGroup>
        </>

    )
}
export default ViewCart


